document.addEventListener('DOMContentLoaded', function() {
  const sliderWrapper = document.querySelector('.slider-wrapper');
  const slides = document.querySelectorAll('.slider-slide');
  const prevButton = document.querySelector('.prev-button');
  const nextButton = document.querySelector('.next-button');
  let currentIndex = 0;
  let startX = 0;
  let isDragging = false;

  function getSlidesToScroll() {
    if (window.innerWidth >= 768) {
      return 3; // Desktop: Move 3 slides at a time
    } else {
      return 1; // Mobile: Move 1 slide at a time
    }
  }

  // Update slider position
  function updateSlider() {
    const slideWidth = slides[0].clientWidth;
    const marginRight = parseInt(window.getComputedStyle(slides[0]).marginRight); // Get margin-right value
    const slidesToScroll = getSlidesToScroll();
    const offset = (slideWidth + marginRight) * currentIndex; // Account for margin-right
    sliderWrapper.style.transform = `translateX(-${offset}px)`;
  }

  // Next slide
  function goToNextSlide() {
    const slidesToScroll = getSlidesToScroll();
    if (currentIndex < slides.length - slidesToScroll) {
      currentIndex += slidesToScroll;
    } else {
      currentIndex = 0; // Loop back to the first slide
    }
    updateSlider();
  }

  // Previous slide
  function goToPrevSlide() {
    const slidesToScroll = getSlidesToScroll();
    if (currentIndex >= slidesToScroll) {
      currentIndex -= slidesToScroll;
    } else {
      currentIndex = slides.length - slidesToScroll; // Loop to the last slide
    }
    updateSlider();
  }

  // Arrow button event listeners
  nextButton.addEventListener('click', goToNextSlide);
  prevButton.addEventListener('click', goToPrevSlide);

  // Touch event listeners for swipe functionality
  sliderWrapper.addEventListener('touchstart', (e) => {
    startX = e.touches[0].clientX;
    isDragging = true;
  });

  sliderWrapper.addEventListener('touchmove', (e) => {
    if (!isDragging) return;
    const currentX = e.touches[0].clientX;
    const diffX = startX - currentX;

    if (Math.abs(diffX) > 50) { // Minimum swipe distance
      if (diffX > 0) {
        goToNextSlide(); // Swipe left (next slide)
      } else {
        goToPrevSlide(); // Swipe right (previous slide)
      }
      isDragging = false;
    }
  });

  sliderWrapper.addEventListener('touchend', () => {
    isDragging = false;
  });

  // Mute/Unmute Functionality
  window.toggleMute = function(blockId) {
    const video = document.querySelector(`.video-${blockId}`);
    const muteIcon = document.getElementById(`mute-icon-${blockId}`);

    if (video && muteIcon) {
      video.muted = !video.muted;
      if (video.muted) {
        // Mute Icon (with diagonal line)
        muteIcon.innerHTML = `
          <path d="M12 6L8 10H6a2 2 0 0 0-2 2v0a2 2 0 0 0 2 2h2l4 4V6zM16 10l4-4M20 10l-4 4" />
          <line x1="2" y1="2" x2="22" y2="22" /> <!-- Diagonal line for mute state -->
        `;
      } else {
        // Unmute Icon
        muteIcon.innerHTML = `
          <path d="M12 6L8 10H6a2 2 0 0 0-2 2v0a2 2 0 0 0 2 2h2l4 4V6zM16 10l4-4M20 10l-4 4" />
        `;
      }
    } else {
      console.error(`Video or mute icon not found for block ID: ${blockId}`);
    }
  };
});

